'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectExpectedResultsModalCreate from "./controller/expectedResultsModalCreate";
import ProjectExpectedResultsTableDirective from "./directive/projectExpectedResultsTable";

export default angular.module('investmentProject.project.fund.expectedResults', [])
    .controller('ProjectExpectedResultsModalCreateController', ProjectExpectedResultsModalCreate)
    .directive('projectExpectedResultsTable', ProjectExpectedResultsTableDirective)
    .name;